// extracted by mini-css-extract-plugin
module.exports = {"icon":"network-selector_icon__7t6fC","wrapper":"network-selector_wrapper__As__w"};